import React from 'react';
import { BookOpenIcon, FileTextIcon, InfoIcon, SkipForwardIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { ChoiceCard } from '../story/ChoiceCard';
import { ActionRow } from '../story/ActionRow';
import { prequelSkipRecap, purrAnchorUnlockNote } from '../../data/prequel';
export function PrequelEntryScreen() {
  const {
    dispatch
  } = useDemo();
  return <ScreenContainer width="narrow" data-id="element-216" data-mp="1qcl66prxo2hy">
      <ScreenHeading eyebrow="Prequel" data-id="element-217" data-mp="1qdo2jd80yx59">SixBefore: The Girl Who Heard Too Much</ScreenHeading>
      <p className="mt-5 flex items-start gap-3 rounded-2xl border border-line bg-sand p-5 hc-strong" data-id="element-218" data-mp="1lbymtk9uxvau">
        <InfoIcon size={20} className="mt-1 shrink-0 text-teal" aria-hidden="true" data-id="element-219" data-mp="1hbwwu8dhiqbe" />
        <span data-id="element-220" data-mp="a067todtkw22">
          This scene includes a hurtful teacher comment and school whispers. You can read it, use a quieter version, or
          skip it.
        </span>
      </p>
      <div className="mt-6 grid gap-3" data-id="element-221" data-mp="1mb2aqtq03qqg">
        <ChoiceCard title="Read the story" summary="Six illustrated panels. You move at your own pace." icon={<BookOpenIcon size={20} aria-hidden="true" data-id="element-223" data-mp="1d9ma3dozn2zf" />} onClick={() => {
        dispatch({
          type: 'SET_PREQUEL_STEP',
          step: 0
        });
        dispatch({
          type: 'GO',
          screen: 'prequelStory'
        });
      }} data-id="element-222" data-mp="1m7xxz7ygzmo6" />
        <ChoiceCard title="Use the quieter version" summary="Three short text cards. Same story, fewer details." icon={<FileTextIcon size={20} aria-hidden="true" data-id="element-225" data-mp="18ccfzkqnm359" />} onClick={() => dispatch({
        type: 'GO',
        screen: 'prequelQuiet'
      })} data-id="element-224" data-mp="13ihxgkmsbu7r" />
        <ChoiceCard title="Skip to the Bridge" summary="Get a short recap and go straight on." icon={<SkipForwardIcon size={20} aria-hidden="true" data-id="element-227" data-mp="klq93wsdyowu" />} onClick={() => dispatch({
        type: 'COMPLETE_PREQUEL',
        route: 'skip',
        recap: `${prequelSkipRecap} ${purrAnchorUnlockNote}`
      })} data-id="element-226" data-mp="yjwxmmbg3cju" />
      </div>
      <p className="mt-4 text-sm text-ink/80" data-id="element-228" data-mp="2rb0l6efmunnu">All three routes reach the same Bridge and the same Field Guide card.</p>
      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-229" data-mp="2hj49u1ojd11o" />
    </ScreenContainer>;
}